export const isLoggedIn = function () {
    return nal.user && !_.isEmpty(nal.user);
};
export const isNotLoggedIn = function (to) {
    return requireAuth(to) && !isLoggedIn();
};
export const requireAuth = function (to) {
    return to.matched.some(record => record.meta.requiresAuth);
};